module.exports = __webpack_public_path__ + "img/logo.746f8145.png";